import React from 'react';
import { useNavigate as useRouterNavigate } from 'react-router-dom';

import ActionCard, { ActionCardVariant } from 'components/Common/Cards/ActionCard';
import { ReactComponent as AssignmentIcon } from 'images/assignment-icon.svg';
import { ReactComponent as ChevronIcon } from 'images/chevron.svg';
import { RoutePath } from 'enums/Routes';

import styles from './LoansHistory.module.scss';

interface LoanHistoryProps {
  count: number;
  title: string;
}

const LoanHistory = ({ count, title }: LoanHistoryProps) => {
  const navigate = useRouterNavigate();

  return (
    <div className={styles.section}>
      <p className={styles.sectionTitle}>{title}</p>

      <ActionCard variant={ActionCardVariant.White} onClick={() => navigate(RoutePath.LoansHistory)}>
        <ActionCard.Row>
          <div className={styles.iconContainer}>
            <AssignmentIcon className={styles.icon} />
          </div>
          <div className={styles.textContainer}>
            <p className={styles.title}>
              {count} past loan{count > 1 ? 's' : ''}
            </p>
          </div>
          <div className={styles.chevronContainer}>
            <ChevronIcon className={styles.chevron} />
          </div>
        </ActionCard.Row>
      </ActionCard>
    </div>
  );
};

export default LoanHistory;
